import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import animation from './gifs/hero_animation.gif';

const ASPECT_RATIO = 41.8 / 25;

type Props = {
    fullscreen?: boolean;
    height?: number;
};

const Loading: React.FC<Props> = ({ fullscreen, height = 25 }) => {
    const width = height * ASPECT_RATIO;

    return (
        <Section centered styles={fullscreen ? { height: '100vh' } : { marginTop: '5rem' }}>
            <img
                src={animation}
                alt="hero-animation-concept-3"
                style={{ width: `${width}rem`, height: `${height}rem` }}
            />
        </Section>
    );
};

export default Loading;
